import React from 'react';
import { css, SerializedStyles } from '@emotion/react';

import { BombBombIcon } from '$/images/Icons';
import { BombBombModal } from '$/sections/Home/Profile/TeamIntegrations/Info/BombBomb/BombBombModal';

import { isBomBombVideoSelected } from '.';
import addOrUpdateVideo from './modifiers/addOrUpdateVideo';
import { DraftJsStyleButtonProps } from '../draft-js-buttons/src';
import { useHasConnectedIntegration } from '$/hooks/useHasConnectedIntegration';
import { IntegrationType } from '$/GraphQL/schema/types';
import { PermissionedLink } from '$/components/Router';
import { rolesPermissionsMatrix } from '$/shared/frontend/rolesPermissionsMatrix';

const BombBombButton: React.FC<{
  hide?: boolean;
  buttonStyles?: SerializedStyles | (SerializedStyles | undefined)[];
  onClick: ((e: any) => void) | undefined;
  onChange?: (video: any) => void;
  onClose?: () => void;
}> = ({ hide, buttonStyles, onChange, onClick, onClose }) => (
  <button css={[buttonStyles]} onClick={onClick} type='button'>
    <BombBombIcon
      className='w-auto'
      css={css`
        height: 1.25rem !important;
      `}
    />
    {onChange && onClose && (
      <BombBombModal hide={Boolean(hide)} onChange={onChange} onClose={onClose} />
    )}
  </button>
);

const BombBombVideoButton: React.FC<DraftJsStyleButtonProps> = (props) => {
  const [showModal, setShowModal] = React.useState(false);
  const hasBombBomb = useHasConnectedIntegration(IntegrationType.BombBomb);

  const onClick = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault();
    e.stopPropagation();
    setShowModal(true);
  };

  const onChange = React.useCallback(
    (video) => {
      const editorState = props?.getEditorState?.();
      if (!editorState) return;
      const nextState = addOrUpdateVideo(editorState, video);
      props?.setEditorState?.(nextState);
      setShowModal(false);
    },
    [props]
  );

  const onClose = (): void => {
    setShowModal(false);
  };

  const { theme } = props;

  const selected = isBomBombVideoSelected(props?.getEditorState?.());
  const buttonStyles = selected ? [theme.button, theme.active] : theme.button;

  if (!hasBombBomb) {
    return (
      <PermissionedLink
        to={`${rolesPermissionsMatrix.settingsIntegrations.path}/BombBomb?successRedirect=${location.pathname}`}
      >
        <BombBombButton buttonStyles={buttonStyles} onClick={undefined} />
      </PermissionedLink>
    );
  }

  return (
    <BombBombButton
      hide={!showModal}
      buttonStyles={buttonStyles}
      onClick={showModal ? undefined : onClick}
      onChange={onChange}
      onClose={onClose}
    />
  );
};

export default BombBombVideoButton;
